import {Injectable} from '@angular/core';
import {Store, StoreConfig} from '@datorama/akita';

export interface CustomApplicationState {
}

export function createInitialState(): CustomApplicationState {
  return {
  };
}

@Injectable({providedIn: 'root'})
@StoreConfig({
  name: 'custom-application',
})
export class CustomApplicationStore extends Store<CustomApplicationState> {

  constructor() {
    super(createInitialState());
  }
}
